// @flow
import { StackActions } from '@react-navigation/native';
import IdentityRequirements from './IdentityRequirements.container';
import { withProps } from 'react-recompose';
import Navigation from '../../../lib/navigation';

const withNavigationProps = () => ({
  goToPassportCheck: () => Navigation.dispatch(StackActions.replace('passportCheckDuringActivate')),
  goToConfirmPersonalInfo: (isEditing: boolean = false) =>
    Navigation.dispatch(StackActions.replace('confirmPersonalInfoDuringActivate', { isManuallyEditing: isEditing })),
});

export default withProps(withNavigationProps)(IdentityRequirements);
